import sanitizeHTML from 'propel/sanitizeHTML';
import { __ } from '@wordpress/i18n';
import getRemBase from 'propel/getRemBase';

const propelInit = function() {
const postsContainers = document.querySelectorAll(
	'[data-view="month"] .filters__post-container'
);

const initializeCards = (postsContainer) => {
	if (postsContainer?.detail?.postsContainer) {
		postsContainer = postsContainer.detail.postsContainer;
	}

	const eventDetailsElement = postsContainer.querySelector(
		'.event-month-details'
	);
	const mobileButtons = postsContainer.querySelectorAll(
		'.event-month-day-card__mobile-button:not(.initialized)'
	);
	const eventButtons = postsContainer.querySelectorAll(
		'.event-month-day-card__event:not(.initialized)'
	);
	const viewMoreButtons = postsContainer.querySelectorAll(
		'.event-month-day-card__view-more-button:not(.initialized), .event-month-details__view-more-button:not(.initialized)'
	);

	const closeMobileDays = () => {
		const dayElements = postsContainer.querySelectorAll(
			'.event-month-details__day'
		);

		dayElements.forEach((dayElement) => {
			dayElement.classList.remove('event-month-details__day--active');
		});

		mobileButtons.forEach((mobileButton) => {
			mobileButton.classList.remove(
				'event-month-day-card__mobile-button--active'
			);
		});
	};

	const removeEventPopups = (button = null) => {
		const popups = postsContainer.querySelectorAll('.event-popup');

		const activeButtons = postsContainer.querySelectorAll(
			'.event-month-day-card__event--active, .event-month-day-card__event--semi-active'
		);
		const activeViewMoreButtons = postsContainer.querySelectorAll(
			'.event-month-day-card__view-more-button--active'
		);

		let closestPopupButton;

		if (button) {
			closestPopupButton = button.closest(
				'.event-month-day-card__event--popup'
			);
		}

		if (!closestPopupButton) {
			document.removeEventListener('keydown', clickOffEvent);
			document.removeEventListener('click', clickOffEvent);
		}

		popups.forEach((popup) => {
			if (
				closestPopupButton &&
				popup.classList.contains('event-popup--events')
			) {
				return;
			}

			popup.remove();
		});

		activeButtons.forEach((activeButton) => {
			if (closestPopupButton && activeButton === closestPopupButton) {
				return;
			}

			activeButton.classList.remove(
				'event-month-day-card__event--active',
				'event-month-day-card__event--semi-active'
			);
		});

		if (!closestPopupButton) {
			activeViewMoreButtons.forEach((activeViewMoreButton) => {
				activeViewMoreButton.classList.remove(
					'event-month-day-card__view-more-button--active'
				);
			});
		}
	};

	const toggleMobileButton = (e) => {
		const mobileButton = e.currentTarget;
		const date = mobileButton.dataset.date ?? null;

		if (!date) {
			return;
		}

		const dayElement = eventDetailsElement.querySelector(
			`.event-month-details__day[data-date="${date}"]`
		);

		if (!dayElement) {
			return;
		}

		if (
			mobileButton.classList.contains(
				'event-month-day-card__mobile-button--active'
			)
		) {
			mobileButton.classList.remove(
				'event-month-day-card__mobile-button--active'
			);

			eventDetailsElement.classList.remove('event-month-details--active');
			dayElement.classList.remove('event-month-details__day--active');
			closeMobileDays();
		} else {
			closeMobileDays();

			mobileButton.classList.add(
				'event-month-day-card__mobile-button--active'
			);

			eventDetailsElement.classList.add('event-month-details--active');
			dayElement.classList.add('event-month-details__day--active');
		}
	};

	const clickOffEvent = (e) => {
		let closestEventPopup;
		let closestEventButton;
		let closestViewMoreButton;

		if (e.key === undefined && e.target) {
			closestEventPopup = e.target.closest('.event-popup');

			closestEventButton = e.target.closest(
				'.event-month-day-card__event'
			);

			closestViewMoreButton = e.target.closest(
				'.event-month-day-card__view-more-button'
			);
		}

		if (
			'click' === e?.type &&
			e.target &&
			e.target.classList.contains('event-popup__close-button')
		) {
			removeEventPopups(e.target);

			return;
		}

		if (e.key && e.key !== 'Escape') {
			return;
		} else if (e.key) {
			removeEventPopups();
		}

		if (
			closestEventPopup?.contains(e.target) ||
			closestEventButton?.contains(e.target) ||
			closestViewMoreButton?.contains(e.target)
		) {
			return;
		}

		removeEventPopups(e.target);
	};

	const toggleEventButton = (e) => {
		const eventButton = e.currentTarget;
		const eventId = eventButton.dataset.eventId ?? null;

		if (!eventId) {
			return;
		}

		const eventElement = eventDetailsElement.querySelector(
			`.event-month-details__event[data-event-id="${eventId}"]`
		);

		if (!eventElement) {
			return;
		}

		if (
			eventButton.classList.contains(
				'event-month-day-card__event--active'
			)
		) {
			eventButton.classList.remove('event-month-day-card__event--active');
			removeEventPopups(e.target);

			return;
		}

		openPopup(eventElement, eventButton);
		eventButton.classList.add('event-month-day-card__event--active');

		if (
			eventButton.classList.contains(
				'event-month-day-card__event--multi-day'
			) &&
			!eventButton.classList.contains(
				'event-month-day-card__event--popup'
			)
		) {
			const additionalDays = postsContainer.querySelectorAll(
				`.event-month-day-card__event[data-event-id="${eventId}"]`
			);

			additionalDays.forEach((additionalDay) => {
				additionalDay.classList.add(
					'event-month-day-card__event--semi-active'
				);
			});
		}
	};

	const openPopup = (contentElement, button) => {
		removeEventPopups(button);

		const eventPopup = contentElement.cloneNode(true);
		eventPopup.className = 'event-popup';

		if (contentElement.classList.contains('event-month-details__event')) {
			eventPopup.classList.add('event-popup--event');
		} else if (contentElement.classList.contains('event-month-day-card')) {
			eventPopup.classList.add('event-popup--events');
		}

		const popupCloseButton = document.createElement('button');
		popupCloseButton.classList.add('event-popup__close-button');
		popupCloseButton.setAttribute('role', 'button');

		popupCloseButton.setAttribute(
			'aria-label',
			__('Close Popup', 'propel')
		);

		eventPopup.appendChild(popupCloseButton);
		button.insertAdjacentElement('afterend', eventPopup);

		const popupRect = eventPopup.getBoundingClientRect();
		const postsContainerRect = postsContainer.getBoundingClientRect();
		const buttonRect = button.getBoundingClientRect();

		const cardRect =
			button?.closest('.event-month-day-card')?.getBoundingClientRect() ??
			popupRect;

		let horizontalOffset = 0;
		let verticalOffset = 0;

		if (popupRect.left < postsContainerRect.left - 20) {
			horizontalOffset = postsContainerRect.left - 20 - popupRect.left;
		} else if (popupRect.right > postsContainerRect.right + 20) {
			horizontalOffset = postsContainerRect.right + 20 - popupRect.right;
		}

		const aboveOffset =
			buttonRect.top - cardRect.top - popupRect.height - 8;
		const belowOffset =
			buttonRect.top - cardRect.top + buttonRect.height + 8;
		const centeredOffset =
			buttonRect.top +
			buttonRect.height / 2 -
			cardRect.top -
			popupRect.height / 2;

		if (
			cardRect.top + belowOffset > 100 &&
			cardRect.top + belowOffset + popupRect.height < window.innerHeight
		) {
			verticalOffset = belowOffset;
		} else if (
			cardRect.top + aboveOffset > 100 &&
			cardRect.top + aboveOffset + popupRect.height < window.innerHeight
		) {
			verticalOffset = aboveOffset;
		} else if (
			cardRect.top + centeredOffset > 100 &&
			cardRect.top + centeredOffset + popupRect.height <
				window.innerHeight
		) {
			verticalOffset = centeredOffset; // Centered
		} else {
			verticalOffset = 100 - cardRect.top;
		}

		eventPopup.style.setProperty(
			'--horizontalOffset',
			`${horizontalOffset / getRemBase()}rem`
		);

		eventPopup.style.setProperty(
			'--verticalOffset',
			`${verticalOffset / getRemBase()}rem`
		);

		eventPopup.focus();

		if (contentElement.classList.contains('event-month-day-card')) {
			const popupEventButtons = eventPopup.querySelectorAll(
				'.event-month-day-card__event'
			);

			popupEventButtons.forEach((popupEventButton) => {
				popupEventButton.classList.add(
					'initialized',
					'event-month-day-card__event--popup'
				);

				popupEventButton.addEventListener('click', toggleEventButton);
			});
		}

		document.addEventListener('keydown', clickOffEvent);
		document.addEventListener('click', clickOffEvent);
		window.addEventListener('propel-filters-toggled', removeEventPopups);
	};

	const toggleViewMoreButton = (e) => {
		const viewMoreButton = e.currentTarget;
		const resultElement = document.createElement('div');

		if (
			!postsContainer?.dataset?.apiUrl ||
			!viewMoreButton?.dataset?.date
		) {
			resultElement.innerText = __('Error loading events', 'propel');
			viewMoreButton.replaceWith(resultElement);
			removeEventPopups(e.target);

			return;
		}

		const card = viewMoreButton
			.closest('.filters__post-container')
			?.querySelector(
				`.event-month-day-card[data-date="${viewMoreButton.dataset.date}"]`
			);

		if (!card) {
			resultElement.innerText = __('Error finding events', 'propel');
			viewMoreButton.replaceWith(resultElement);
			removeEventPopups(e.target);

			return;
		}

		if (
			viewMoreButton.classList.contains(
				'event-month-day-card__view-more-button--loaded'
			)
		) {
			if (
				viewMoreButton.classList.contains(
					'event-month-day-card__view-more-button--active'
				)
			) {
				removeEventPopups();
			} else {
				openPopup(card, viewMoreButton);

				viewMoreButton.classList.add(
					'event-month-day-card__view-more-button--active'
				);
			}

			return;
		}

		removeEventPopups(e.target);
		viewMoreButton.innerText = __('Loading…', 'propel');

		viewMoreButton.classList.add(
			'event-month-day-card__view-more-button--loading'
		);

		const url = `${postsContainer.dataset.apiUrl}&month_day_card=${viewMoreButton.dataset.date}`;

		fetchEvents(url, viewMoreButton, card);
	};

	const fetchEvents = async (url, viewMoreButton, card) => {
		try {
			const response = await fetch(url);

			if (!response.ok) {
				throw new Error('There was an error fetching posts');
			}

			const json = await response.json();

			if (null !== json && json?.[0]?.card) {
				const newCard = document.createElement('div');
				newCard.innerHTML = sanitizeHTML(json[0].card);
				const cardContent = card.querySelector(
					'.event-month-day-card__content'
				);

				const currentEvents = card.querySelectorAll(
					'.event-month-day-card__event'
				);

				const currentEventIds = Array.from(currentEvents).map((event) =>
					event.getAttribute('data-event-id')
				);

				const eventElements = newCard.querySelectorAll(
					'.event-month-day-card__event'
				);

				eventElements.forEach((eventElement) => {
					if (
						eventElement?.dataset?.eventId &&
						currentEventIds.includes(eventElement.dataset.eventId)
					) {
						return;
					}

					eventElement.classList.add(
						'event-month-day-card__event--appended'
					);

					cardContent.appendChild(eventElement);
				});

				if (json?.[1]?.card) {
					const newDetails = document.createElement('div');
					newDetails.innerHTML = sanitizeHTML(json[1].card);

					const newDateDetails = newDetails.querySelector(
						`.event-month-details__day[data-date="${viewMoreButton.dataset.date}"]`
					);
					const existingDateDetails =
						eventDetailsElement.querySelector(
							`.event-month-details__day[data-date="${viewMoreButton.dataset.date}"]`
						);

					if (newDateDetails && existingDateDetails) {
						const currentDetailEvents =
							existingDateDetails.querySelectorAll(
								'.event-month-details__event'
							);

						const currentDetailEventIds = Array.from(
							currentDetailEvents
						).map((event) => event.getAttribute('data-event-id'));

						const eventDetailsElements =
							newDateDetails.querySelectorAll(
								'.event-month-details__event'
							);

						eventDetailsElements.forEach((eventElement) => {
							if (
								eventElement?.dataset?.eventId &&
								currentDetailEventIds.includes(
									eventElement.dataset.eventId
								)
							) {
								return;
							}

							existingDateDetails.appendChild(eventElement);
						});
					}
				}

				if (
					viewMoreButton.classList.contains(
						'event-month-details__view-more-button'
					)
				) {
					viewMoreButton.remove();
				} else {
					viewMoreButton.innerText =
						viewMoreButton.dataset.text ??
						__('View more…', 'propel');

					openPopup(card, viewMoreButton);

					viewMoreButton.classList.add(
						'event-month-day-card__view-more-button--loaded',
						'event-month-day-card__view-more-button--active'
					);
				}
			} else {
				viewMoreButton.innerText = __('Error. Try Again.', 'propel');
			}
		} catch (error) {
			console.log(error); // eslint-disable-line no-console
			viewMoreButton.innerText = __('Error. Try Again.', 'propel');
		}

		viewMoreButton.classList.remove(
			'event-month-day-card__view-more-button--loading'
		);

		initializeCards(postsContainer);

		if (
			viewMoreButton.classList.contains(
				'event-month-details__view-more-button'
			)
		) {
			const currentDay = eventDetailsElement.querySelector(
				`.event-month-details__day[data-date="${viewMoreButton.dataset.date}"]`
			);
			const mobileButton = postsContainer.querySelector(
				`.event-month-day-card__mobile-button[data-date="${viewMoreButton.dataset.date}"]`
			);
			const desktopViewMoreButton = postsContainer.querySelector(
				`.event-month-day-card__view-more-button[data-date="${viewMoreButton.dataset.date}"]`
			);

			if (currentDay) {
				currentDay.classList.add('event-month-details__day--active');
			}

			if (mobileButton) {
				mobileButton.classList.add(
					'event-month-day-card__mobile-button--active'
				);
			}

			if (desktopViewMoreButton) {
				desktopViewMoreButton.innerText =
					desktopViewMoreButton.dataset.text ??
					__('View more…', 'propel');

				desktopViewMoreButton.classList.add(
					'event-month-day-card__view-more-button--loaded'
				);
			}
		}
	};

	if (eventDetailsElement) {
		mobileButtons.forEach((mobileButton) => {
			mobileButton.classList.add('initialized');
			mobileButton.addEventListener('click', toggleMobileButton);
		});

		eventButtons.forEach((eventButton) => {
			eventButton.classList.add('initialized');
			eventButton.addEventListener('click', toggleEventButton);
		});
	}

	viewMoreButtons.forEach((viewMoreButton) => {
		viewMoreButton.classList.add('initialized');
		viewMoreButton.addEventListener('click', toggleViewMoreButton);
	});
};

postsContainers.forEach((postsContainer) => {
	initializeCards(postsContainer);
});

window.addEventListener('propel-filters-render-posts', initializeCards);

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['event-month-day-card'] = window.propel.blocks['event-month-day-card'] || {};
window.propel.blocks['event-month-day-card'].script = propelInit;
